module.exports = __webpack_public_path__ + "img/core-3.085bb27.png";